import { ELProduct, NGProduct } from 'features/simulation/types'
import { CookieKeys } from 'types/cookies'
import { readCookie } from 'utils/cookies'
import { fetchMarketingStoreFromSessionStorage } from 'utils/startUp'
import { MarketingActionTypes } from './actions/types'
import { UPDATE_MARKETING_DATA } from './actions/updateMarketingData'
import { MarketingDataKeys, MarketingStore, ProducerVisual, SignChannel, SimulationType } from './types'

const initialState: MarketingStore = fetchMarketingStoreFromSessionStorage() || {
  [MarketingDataKeys.ADJUSTABLE_PRODUCT]: false,
  [MarketingDataKeys.AGENT_ID]: '',
  [MarketingDataKeys.BANNER_TYPE]: '',
  [MarketingDataKeys.CAMPAIGN_NAME]: '',
  [MarketingDataKeys.CONFIRMATION_ROUNDUP]: false,
  [MarketingDataKeys.DEFAULT_ELECTRICITY_PRODUCT]: ELProduct.VariableOn,
  [MarketingDataKeys.DEFAULT_GAS_PRODUCT]: NGProduct.VariableOn,
  [MarketingDataKeys.EMAIL_CONFIRMATION_FLOW]: false,
  [MarketingDataKeys.EAN_CODE_MANDATORY]: false,
  [MarketingDataKeys.GCLID]: readCookie(CookieKeys.GCLID),
  [MarketingDataKeys.LEAD_SOURCE]: '',
  [MarketingDataKeys.NO_EAN_FLOW]: false,
  [MarketingDataKeys.NO_OPTIN_ONE]: false,
  [MarketingDataKeys.NURTURE_FLOW]: '',
  [MarketingDataKeys.PARTNER_ID]: '',
  [MarketingDataKeys.PRODUCER_VISUAL]: ProducerVisual.THREE_CHOICES,
  [MarketingDataKeys.RESET_BUTTON]: false,
  [MarketingDataKeys.SHIFT_ID]: '',
  [MarketingDataKeys.SIGN_CHANNEL]: SignChannel.NONE,
  [MarketingDataKeys.SIMULATION_SO]: '',
  [MarketingDataKeys.SIMULATION_TYPE]: SimulationType.PRICING_SIMULATION,
  [MarketingDataKeys.SOURCE_TYPE]: '',
  [MarketingDataKeys.TRIGGER_EVENTS]: ''
}

export const reducer = (state = initialState, action: MarketingActionTypes): MarketingStore => {
  switch (action.type) {
    case UPDATE_MARKETING_DATA: {
      const { key, value } = action

      return {
        ...state,
        [key]: value
      }
    }

    default:
      return state
  }
}
